import p from "../../../../src/components/3dtransforms/style";
import Example from "../../../../src/pages/css-3d-transform-examples/_Example";
import * as React from 'react';
export default {
  p,
  Example,
  React
};